import { createContext } from 'react';

const snackbarContext = createContext();
const paginationContext = createContext();

export { paginationContext, snackbarContext };
